import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const OpenLinkIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      d="M9.29167 9.29167H1.70833V1.70833H5.5V0.625H1.70833C1.42102 0.625 1.14547 0.739137 0.942301 0.942301C0.739137 1.14547 0.625 1.42102 0.625 1.70833V9.29167C0.625 9.57899 0.739137 9.85454 0.942301 10.0577C1.14547 10.2609 1.42102 10.375 1.70833 10.375H9.29167C9.8875 10.375 10.375 9.8875 10.375 9.29167V5.5H9.29167V9.29167ZM6.58333 0.625V1.70833H8.52792L3.20333 7.03292L3.96708 7.79667L9.29167 2.47208V4.41667H10.375V0.625H6.58333Z"
      fill="#FD740D"
    />
  </svg>
);

OpenLinkIcon.propTypes = {
  color: string.isRequired,
  fillOpacity: number,
  ...helpers.iconDimensionsPropTypes,
};

OpenLinkIcon.defaultProps = {
  color: '#fd740d',
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(11, 11),
};

export default OpenLinkIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/open-link.js